<app-load-dropdown-data [formName]="formName" (fillDropdownData)="fillDropdownData()"></app-load-dropdown-data>
<div class="container-fluid d-flex flex-column h-100 p-0 px-3 px-sm-0">
  <div class="row gap-2 my-2 mx-0 h-100 InstallmentReport_container">
    <div class="width_21rem h-100 m-0 page-size-dropdown px-0 InstallmentReport_ledgerlist">
      <div class="card h-100 d-flex flex-column m-0">
        <div class="row mx-0">
          <div class="col-12 px-0">
            <div
              class="card-header px-1 py-1 d-flex justify-content-end align-items-center">  
            </div>
          </div>
        </div>
        <div class="row flex-column h-100 mx-0">
          <div class="col-12 p-0 flex-fill h-0 mb-2 position-relative">
            <app-ag-grid 
                [dataModel]="agGridDataModelInstallmentReportList" 
                (gridReady)="onGridReady($event,storageName?.TRANSACTION_INSTALLMENT_REPORT_LEDGERLIST_GRID)" 
                (rowClicked)="rowClicked($event)"
                [tableRowCellEditable]="false"
                [columnSettings]="true"
                (onDeleteIconClick)="onDeleteIconClick($event)"
                >
            </app-ag-grid>
        </div>
        </div>
      </div>
    </div>
    <div class="card col d-flex flex-column h-100 m-0 mb-0 py-2 InstallmentReport_ledgerDetails">
      <div class="d-flex flex-column flex-fill">
          <div class="d-flex flex-column flex-fill">
            <div class="col-12 flex-fill mb-0 h-0 position-relative">
              <app-ag-grid 
                #memoReportDetails_grid
                [dataModel]="agGridDataModelInstallmentReportDetailsList" 
                (gridReady)="onGridReady($event,storageName?.TRANSACTION_INSTALLMENTREPORT_DETAILS_GRID)"  
                [columnSettings]="true"
                (onTextCellClick) = "handleTextClick($event)"
                (onPrintButtonClick)="onPrintButtonClick($event)">
              </app-ag-grid>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>










